export default __webpack_public_path__ + "static/media/trovoada.83d1734d.svg";